export default {
  jp: {
    title: '会社検索',
    label: {
      companyName: '会社名'
    },
    notes: {
      companyName: '※会社名の一部を入力の上、検索してください。（漢字・カナ可）',
      clubOfficialMedia: '※クラブオフィシャルメディアの方は、クラブ名を入力の上、検索してください。'
    },
    button: {
      search: '検索',
      close: '閉じる'
    },
    table: {
      label: {
        group: '所属',
        company: '会社'
      },
      message: {
        searchNoData: '該当する会社は存在しません。'
      }
    }
  },
  en: {
    title: 'Company Search',
    label: {
      companyName: 'Company Name'
    },
    notes: {
      companyName: '※Please enter part of the company name to search. ',
      clubOfficialMedia: '※If you are a club official media, please enter club name to search.'
    },
    button: {
      search: 'Search',
      close: 'Close'
    },
    table: {
      label: {
        group: 'Group',
        company: 'Company'
      },
      message: {
        searchNoData: 'There are no applicable companies.'
      }
    }
  }
}
